import { Component, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";

import { ViewerService } from "../../services";

@Component({
    selector: 'gsp-pdf-viewer',
    templateUrl: './viewer.component.html',
})
export class ViewerComponent implements OnInit {

    documentID: string;
    showViewer = false;
    pdfData: any;
    @ViewChild('pdfViewer') pdfViewer;

    constructor(private _viewerService: ViewerService, private route: ActivatedRoute,
        private sanitizer: DomSanitizer, ) {
    }

    ngOnInit() {
        this.documentID = this.route.snapshot.paramMap.get("documentID")
        this._viewerService.getDocument(this.documentID).subscribe(
            response => {
                // scope.pdfData = scope.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + response);   
                //    this.pdfViewer.pdfSrc = response;   
                //    this.pdfViewer.refresh();
                
                let ua = window.navigator.userAgent;
                let isIE = /MSIE|Trident|Edge\//.test(ua);

                // IE workaround
                if ( isIE ) {
                    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) { 
                        let byteCharacters = atob(response);
                        let byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        let byteArray = new Uint8Array(byteNumbers);
                        let blob = new Blob([byteArray], {type: 'application/pdf'});
                       (window.navigator as any).msSaveOrOpenBlob(blob, "policy.pdf");
                    }
                } else {

                    // Option 1 (Disabled) - Renders document in broswer
                    this.showViewer = true;
                    this.pdfData = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + response);

                    // Options 2 - (Current) - Opens docuemnt autoatically
                    let byteCharacters = atob(response);
                    let byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let blob = new Blob([byteArray], {type: 'application/pdf'});
                    let fileURL = URL.createObjectURL(blob);
                    window.open(fileURL, '_self'); 

                }
            }
        );
    }
}
